// @flow

import _ from 'lodash/fp';
import {combineReducers} from 'redux';
import {
  FILE_ADDED, UPLOAD_PROGRESS,
  UPLOAD_SUCCESS, UPLOAD_ERROR,
  REMOVE_UPLOAD, UPLOAD_INITIALIZED,
} from '../actions/file';

const filesById = (state = {}, action) => {
  switch (action.type) {
    case FILE_ADDED:
      return {
        ...state,
        [action.tempId]: {
          tempId: action.tempId,
          file: action.file,
          progress: 0,
          metadata: null,
          error: null,
          id: null,
        },
      };

    case UPLOAD_INITIALIZED:
      return {
        ...state,
        [action.tempId]: {
          ...state[action.tempId],
          id: action.id,
        },
      };

    case UPLOAD_PROGRESS:
      return {
        ...state,
        [action.tempId]: {
          ...state[action.tempId],
          progress: action.progress,
        },
      };

    case UPLOAD_SUCCESS:
      return {
        ...state,
        [action.tempId]: {
          ...state[action.tempId],
          progress: 100,
          metadata: action.metadata,
          error: null,
        },
      };

    case UPLOAD_ERROR:
      return {
        ...state,
        [action.tempId]: {
          ...state[action.tempId],
          error: action.error,
        },
      };

    case REMOVE_UPLOAD:
      return {
        ...state,
        [action.tempId]: undefined,
      };

    default:
      return state;
  }
};

const allFileIds = (state = [], action) => {
  switch (action.type) {
    case FILE_ADDED:
      return [
        ...state,
        action.tempId,
      ];

    case REMOVE_UPLOAD:
      return _.reject({tempId: action.tempId}, state);

    default:
      return state;
  }
};

const files = combineReducers({
  byId: filesById,
  allIds: allFileIds,
});

export default files;



// WEBPACK FOOTER //
// ./src/reducers/files.js